<div class="card-wrapper">
    <ion-card>
        <ion-card-header>
            <h4>{{'syndicate-loading.generating-syndicates'|translate}}</h4>
        </ion-card-header>
        <ion-card-content>
            <div>
                <p>{{'syndicate-loading.product-text'|translate}}.</p>
            </div>
            <ion-button class="purple-btn" (click)="goToSyndicate()">
                {{'syndicate-loading.view-ticket'|translate}}
            </ion-button>
        </ion-card-content>
    </ion-card>
</div>